import { NgModule } from 'angular-ts-decorators';
import { CalloutMessageComponent } from './components';

@NgModule({
  declarations: [CalloutMessageComponent],
  id: 'gn.audio.public.shared',
  imports: [],
  providers: [],
})
export class SharedModule {
}
